module.exports = __webpack_public_path__ + "static/media/stop.3abf8a57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/stop.svg
// module id = 918
// module chunks = 0